import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService } from '@shared/helpers/sesion.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  constructor(private http :HttpClient,private sessionService : SessionService) {}

  LogAccionesTrasabilidad(request : any) {
    request.idUser = Number(this.sessionService.getIdUserSession()) == 0 ? request.idUser  : Number(this.sessionService.getIdUserSession());
    request.json = JSON.stringify(request.json);
     this.LogAccionesTrasabilidadService(request).subscribe(x => {
     },err => {console.log(err);})
  }
  LogAccionesTrasabilidadService(request : any ): Observable<any>{
    return this.http.post<any>(environment.apiBaseUrl + "api/Logs/LogAccionesTrasabilidad",request);
  }
}
